export const SET_CART_PAGE_STATUS = 'SET_CART_PAGE_STATUS' as const;
export const OPEN_LOCATION_CHANGE_MODAL = 'OPEN_LOCATION_CHANGE_MODAL' as const;
export const ADD_PROMO_CODE = 'ADD_PROMO_CODE' as const;
export const REMOVE_PROMO_CODE = 'REMOVE_PROMO_CODE' as const;
export const SET_PROMO_CODE_APPLIED = 'SET_PROMO_CODE_APPLIED' as const;
export const CLOSE_MODAL = 'CLOSE_MODAL' as const;
export const SET_CONNECTION_ID = 'SET_CONNECTION_ID' as const;
export const TRIGGER_CART_REFETCH = 'TRIGGER_CART_REFETCH' as const;
export const CARD_TYPE_CART = 'cart' as const;
export const CARD_TYPE_SAVED = 'saved' as const;
export const MAX_CART_ITEMS = 15;

type CartPageStatus = 'idle' | 'loading' | 'error';
export type CardType = 'cart' | 'saved';
type CartModal = 'locationChange' | null;

type PromoCodeItem = {
    skuId: string;
    promoCode: string;
};

type State = {
    cartPageStatus: CartPageStatus;
    cartModal: CartModal;
    connections: { connectionType: CardType; connectionId: string }[];
    promoCodeItems: PromoCodeItem[];
    hasPromoCodeApplied: boolean;
    refetchTrigger: number;
};

export type CartPageActions =
    | { type: typeof SET_CART_PAGE_STATUS; cartPageStatus: CartPageStatus }
    | { type: typeof OPEN_LOCATION_CHANGE_MODAL }
    | { type: typeof CLOSE_MODAL }
    | { type: typeof SET_CONNECTION_ID; connectionType: CardType; connectionId: string }
    | { type: typeof ADD_PROMO_CODE; skuId: string; promoCode: string }
    | { type: typeof REMOVE_PROMO_CODE; skuId: string }
    | { type: typeof SET_PROMO_CODE_APPLIED; hasPromoCodeApplied: boolean }
    | { type: typeof TRIGGER_CART_REFETCH };

const getInitialState = (): State => ({
    cartPageStatus: 'idle',
    connections: [],
    cartModal: null,
    promoCodeItems: [],
    hasPromoCodeApplied: false,
    refetchTrigger: 0,
});

export const cartPageReducer = (state = getInitialState(), action: CartPageActions): State => {
    switch (action.type) {
        case SET_CONNECTION_ID:
            return {
                ...state,
                connections: [
                    ...state.connections,
                    { connectionType: action.connectionType, connectionId: action.connectionId },
                ],
            };
        case SET_CART_PAGE_STATUS:
            return { ...state, cartPageStatus: action.cartPageStatus };
        case OPEN_LOCATION_CHANGE_MODAL:
            return { ...state, cartModal: 'locationChange' };
        case CLOSE_MODAL:
            return { ...state, cartModal: null };
        case ADD_PROMO_CODE:
            return {
                ...state,
                promoCodeItems: [
                    ...state.promoCodeItems.filter(item => item.skuId !== action.skuId),
                    { skuId: action.skuId, promoCode: action.promoCode },
                ],
            };
        case REMOVE_PROMO_CODE:
            return {
                ...state,
                promoCodeItems: state.promoCodeItems.filter(item => item.skuId !== action.skuId),
            };
        case SET_PROMO_CODE_APPLIED:
            return {
                ...state,
                hasPromoCodeApplied: action.hasPromoCodeApplied,
            };
        case TRIGGER_CART_REFETCH:
            return {
                ...state,
                refetchTrigger: state.refetchTrigger + 1,
            };

        default:
            return state;
    }
};
